<template>
  <div class="messageTraceBox">
    <a-table
      :dataSource="dataSource"
      :rowkey="(_, index) => index"
      class="my-table"
      :pagination="false"
      :columns="columns"
    >
      <template #sendPersonRole="{ record }">
        <Roles :solerType="record.sendPersonRole" />
        {{ record.sendPerson }}
      </template>
      <template #receivePersonRole="{ record }">
        <Roles :solerType="record.receivePersonRole" />
        {{ record.receivePerson }}
      </template>
      <template #sendStatus="{ record }">
        <a-tag v-if="record.sendStatus" color="success">发送成功</a-tag>
        <a-tag v-else color="error">发送失败</a-tag>
      </template>
      <template #smsInfo="{ text }">
        <a-tooltip
          :getPopupContainer="getPopupContainer"
          overlayClassName="my-tooltip"
          placement="bottom"
          class="two-line"
        >
          <template #title>{{ text }}</template>
          <div class="tooltip-body">
            {{ text }}
          </div>
        </a-tooltip>
      </template>
    </a-table>
  </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { messageTraceIds } from '@/api/workPlace/workOrder'
import Roles from '@/components/Roles'

const dataSource = ref([])
const columns = ref([
  {
    title: '发送人',
    dataIndex: 'sendPersonRole',
    key: 'sendPersonRole',
    width: 130,
    slots: { customRender: 'sendPersonRole' }
  },
  {
    title: '接收人',
    dataIndex: 'receivePersonRole',
    key: 'receivePersonRole',
    width: 130,
    slots: { customRender: 'receivePersonRole' }
  },
  {
    title: '发送时间',
    dataIndex: 'sendTime',
    width: 120,
    key: 'sendTime'
  },
  {
    title: '发送状态',
    dataIndex: 'sendStatus',
    key: 'sendStatus',
    width: 90,
    slots: { customRender: 'sendStatus' }
  },
  {
    title: '触达状态',
    dataIndex: 'reachStatusDesc',
    key: 'reachStatusDesc',
    width: 90
  },
  {
    title: '已读情况',
    width: 90,
    dataIndex: 'readStatusDesc',
    key: 'readStatusDesc'
  },
  {
    title: '发送类型',
    dataIndex: 'sendTypeSnapshot',
    width: 200,
    key: 'sendTypeSnapshot'
  },
  {
    title: '短信详情',
    dataIndex: 'smsInfo',
    key: 'smsInfo',
    width: 300,
    slots: { customRender: 'smsInfo' }
  }
])

const queryTraceByIds = (Ids = []) => {
  messageTraceIds({ ids: Ids }).then(res => {
    dataSource.value = res || []
  })
}

const getPopupContainer = trigger => {
  return trigger.parentNode
}

defineExpose({
  queryTraceByIds
})
</script>

<style lang="scss" scoped>
.messageTraceBox {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 10px;
}

::v-deep(.my-table) {
  // display: block;
  .two-line {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

// 黑色弹出的提示内容框 样式
::v-deep(.my-tooltip) {
  .ant-tooltip-content {
    .ant-tooltip-inner {
      min-width: 200px;
      border-radius: 4px;
    }
  }
}
</style>
